"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURATION_KEYS = void 0;
const _1 = require(".");
/* tslint:disable:no-object-literal-type-assertion */
const baseName = "dailyDevStats";
exports.CONFIGURATION_KEYS = {
    metrics: {
        filters: {
            includePrDrafts: {
                name: `${baseName}.metrics.filters.includePrDrafts`,
                chain: [],
                type: {}
            },
            includeAggregatedPrs: {
                name: `${baseName}.metrics.filters.includeAggregatedPrs`,
                chain: [],
                type: {}
            },
            includeInternalPrs: {
                name: `${baseName}.metrics.filters.includeInternalPrs`,
                chain: [],
                type: {}
            },
            highPriorityOrder: {
                name: `${baseName}.metrics.filters.highPriorityOrder`,
                chain: [],
                type: {}
            },
            acumenBugTaskType: {
                name: `${baseName}.metrics.filters.acumenBugTaskType`,
                chain: [],
                type: {}
            },
            ignorePrClosedStateInCycle: {
                name: `${baseName}.metrics.filters.ignorePrClosedStateInCycle`,
                chain: [],
                type: {}
            },
        }
    },
    selectedMetrics: {
        name: `${baseName}.selectedMetrics`,
        chain: [_1.ConfigurationEntityType.DataContributor],
        type: {}
    },
    badges: {
        lowActivityPercent: {
            name: "devStats.badges.lowActivityPercent",
            chain: [],
            type: {}
        },
        minNumberOfMergedPrsForPositiveBadges: {
            name: "devStats.badges.minNumberOfMergedPrsForPositiveBadges",
            chain: [],
            type: {}
        },
        velocityBadge: {
            superStarPercentileThreshold: {
                name: "devStats.badges.velocityBadge.superStarPercentileThreshold",
                chain: [],
                type: {}
            },
            needAttentionPercentileThreshold: {
                name: "devStats.badges.velocityBadge.needAttentionPercentileThreshold",
                chain: [],
                type: {}
            },
            needAttentionPrevPeriodDecreasePercentageThreshold: {
                name: "devStats.badges.velocityBadge.needAttentionPrevPeriodDecreasePercentageThreshold",
                chain: [],
                type: {}
            },
            onTheRisePrevPeriodIncreasePercentageThreshold: {
                name: "devStats.badges.velocityBadge.onTheRisePrevPeriodIncreasePercentageThreshold",
                chain: [],
                type: {}
            },
            onTheRiseMinPercentileThreshold: {
                name: "devStats.badges.velocityBadge.onTheRiseMinPercentileThreshold",
                chain: [],
                type: {}
            },
            calculationMethod: {
                name: "devStats.badges.velocityBadge.calculationMethod",
                chain: [],
                type: {}
            }
        },
        highPriorityBadge: {
            disable: {
                name: "devStats.badges.highPriorityBadge.disable",
                chain: [],
                type: {}
            },
            superStarPercentileThreshold: {
                name: "devStats.badges.highPriorityBadge.superStarPercentileThreshold",
                chain: [],
                type: {}
            },
            teamPlayerPercentileThreshold: {
                name: "devStats.badges.highPriorityBadge.teamPlayerPercentileThreshold",
                chain: [],
                type: {}
            },
            onTheRisePrevPeriodIncreasePercentageThreshold: {
                name: "devStats.badges.highPriorityBadge.onTheRisePrevPeriodIncreasePercentageThreshold",
                chain: [],
                type: {}
            },
            onTheRiseMinPercentileThreshold: {
                name: "devStats.badges.highPriorityBadge.onTheRiseMinPercentileThreshold",
                chain: [],
                type: {}
            },
            minNumberOfCompletedTasks: {
                name: "devStats.badges.highPriorityBadge.minNumberOfCompletedTasks",
                chain: [],
                type: {}
            }
        },
        reviewedPRsBadge: {
            superStarPercentileThreshold: {
                name: "devStats.badges.reviewedPRsBadge.superStarPercentileThreshold",
                chain: [],
                type: {}
            },
            needAttentionPercentileThreshold: {
                name: "devStats.badges.reviewedPRsBadge.needAttentionPercentileThreshold",
                chain: [],
                type: {}
            },
            needAttentionOverTeamPercentageThreshold: {
                name: "devStats.badges.reviewedPRsBadge.needAttentionOverTeamPercentageThreshold",
                chain: [],
                type: {}
            },
            onTheRisePrevPeriodIncreasePercentageThreshold: {
                name: "devStats.badges.reviewedPRsBadge.onTheRisePrevPeriodIncreasePercentageThreshold",
                chain: [],
                type: {}
            },
            teamPlayerRatioForMergedAndReviewedPrs: {
                name: "devStats.badges.reviewedPRsBadge.teamPlayerRatioForMergedAndReviewedPrs",
                chain: [],
                type: {}
            },
            teamPlayerMinPercentileThreshold: {
                name: "devStats.badges.reviewedPRsBadge.teamPlayerMinPercentileThreshold",
                chain: [],
                type: {}
            }
        },
        prSizeBadge: {
            superStarPercentileThreshold: {
                name: "devStats.badges.prSizeBadge.superStarPercentileThreshold",
                chain: [],
                type: {}
            },
            superStarPrSizeThreshold: {
                name: "devStats.badges.prSizeBadge.superStarPrSizeThreshold",
                chain: [],
                type: {}
            },
            needAttentionPrSizeThreshold: {
                name: "devStats.badges.prSizeBadge.needAttentionPrSizeThreshold",
                chain: [],
                type: {}
            },
            needAttentionPercentileThreshold: {
                name: "devStats.badges.prSizeBadge.needAttentionPercentileThreshold",
                chain: [],
                type: {}
            },
            needAttentionPrevPeriodPrSizeIncreasePercentageThreshold: {
                name: "devStats.badges.prSizeBadge.needAttentionPrevPeriodPrSizeIncreasePercentageThreshold",
                chain: [],
                type: {}
            },
            needAttentionMinPRSizeThreshold: {
                name: "devStats.badges.prSizeBadge.needAttentionMinPRSizeThreshold",
                chain: [],
                type: {}
            },
            onTheRisePrSizeThreshold: {
                name: "devStats.badges.prSizeBadge.onTheRisePrSizeThreshold",
                chain: [],
                type: {}
            },
            onTheRisePrevPeriodPrSizeDecreasePercentageThreshold: {
                name: "devStats.badges.prSizeBadge.onTheRisePrevPeriodPrSizeDecreasePercentageThreshold",
                chain: [],
                type: {}
            },
        },
        prCycleTimeBadge: {
            superStarPercentileThreshold: {
                name: "devStats.badges.prCycleTimeBadge.superStarPercentileThreshold",
                chain: [],
                type: {}
            },
            needAttentionPercentileThreshold: {
                name: "devStats.badges.prCycleTimeBadge.needAttentionPercentileThreshold",
                chain: [],
                type: {}
            },
            needAttentionPrevPeriodIncreasePercentageThreshold: {
                name: "devStats.badges.prCycleTimeBadge.needAttentionPrevPeriodIncreasePercentageThreshold",
                chain: [],
                type: {}
            },
            needAttentionMinPercentileThreshold: {
                name: "devStats.badges.prCycleTimeBadge.needAttentionMinPercentileThreshold",
                chain: [],
                type: {}
            },
            onTheRisePrevPeriodDecreasePercentageThreshold: {
                name: "devStats.badges.prCycleTimeBadge.onTheRisePrevPeriodDecreasePercentageThreshold",
                chain: [],
                type: {}
            },
            onTheRiseMaxPercentileThreshold: {
                name: "devStats.badges.prCycleTimeBadge.onTheRiseMaxPercentileThreshold",
                chain: [],
                type: {}
            }
        }
    },
    teamBadges: {
        numberOfPeriodsForTrendCalculation: {
            name: `${baseName}.teamBadges.numberOfPeriodsForTrendCalculation`,
            chain: [],
            type: {}
        },
        velocityBadge: {
            topPerformerPercentileThreshold: {
                name: `${baseName}.teamBadges.velocityBadge.topPerformerPercentileThreshold`,
                chain: [],
                type: {}
            },
            onTheRisePercentileThreshold: {
                name: `${baseName}.teamBadges.velocityBadge.onTheRisePercentileThreshold`,
                chain: [],
                type: {}
            },
            needAttentionPercentileThreshold: {
                name: `${baseName}.teamBadges.velocityBadge.needAttentionPercentileThreshold`,
                chain: [],
                type: {}
            },
            disable: {
                name: `${baseName}.teamBadges.velocityBadge.disable`,
                chain: [],
                type: {}
            },
        },
        avgPRCycleTimeAwaitingReviewBadge: {
            topPerformerAwaitingReviewHours: {
                name: `${baseName}.teamBadges.avgPRCycleTimeAwaitingReviewBadge.topPerformerAwaitingReviewHours`,
                chain: [],
                type: {}
            },
            needAttentionAwaitingReviewHours: {
                name: `${baseName}.teamBadges.avgPRCycleTimeAwaitingReviewBadge.needAttentionAwaitingReviewHours`,
                chain: [],
                type: {}
            },
            disable: {
                name: `${baseName}.teamBadges.avgPRCycleTimeAwaitingReviewBadge.disable`,
                chain: [],
                type: {}
            },
        },
        avgPRSizeBadge: {
            topPerformerPercentileThreshold: {
                name: `${baseName}.teamBadges.avgPRSizeBadge.topPerformerPercentileThreshold`,
                chain: [],
                type: {}
            },
            topPerformerPrSizeThresholdForTopPercentile: {
                name: `${baseName}.teamBadges.avgPRSizeBadge.topPerformerPrSizeThresholdForTopPercentile`,
                chain: [],
                type: {}
            },
            topPerformerPrSizeThreshold: {
                name: `${baseName}.teamBadges.avgPRSizeBadge.topPerformerPrSizeThreshold`,
                chain: [],
                type: {}
            },
            onTheRisePercentileThreshold: {
                name: `${baseName}.teamBadges.avgPRSizeBadge.onTheRisePercentileThreshold`,
                chain: [],
                type: {}
            },
            needAttentionPrSizeThreshold: {
                name: `${baseName}.teamBadges.avgPRSizeBadge.needAttentionPrSizeThreshold`,
                chain: [],
                type: {}
            },
            needAttentionNegativeTrendPrSizeThreshold: {
                name: `${baseName}.teamBadges.avgPRSizeBadge.needAttentionNegativeTrendPrSizeThreshold`,
                chain: [],
                type: {}
            },
            disable: {
                name: `${baseName}.teamBadges.avgPRSizeBadge.disable`,
                chain: [],
                type: {}
            },
        },
        avgPRCycleTimeBadge: {
            topPerformerPercentileThreshold: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.topPerformerPercentileThreshold`,
                chain: [],
                type: {}
            },
            topPerformerPrCycleTimeThresholdHoursForTopPercentile: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.topPerformerPrCycleTimeThresholdHoursForTopPercentile`,
                chain: [],
                type: {}
            },
            useTopPerformerThresholdForTopPercentile: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.useTopPerformerThresholdForTopPercentile`,
                chain: [],
                type: {}
            },
            topPerformerPrCycleTimeThresholdHours: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.topPerformerPrCycleTimeThresholdHours`,
                chain: [],
                type: {}
            },
            onTheRisePercentileThreshold: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.onTheRisePercentileThreshold`,
                chain: [],
                type: {}
            },
            needAttentionPrCycleTimeThresholdHours: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.needAttentionPrCycleTimeThresholdHours`,
                chain: [],
                type: {}
            },
            needAttentionNegativeTrendPrCycleTimeThresholdHours: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.needAttentionNegativeTrendPrCycleTimeThresholdHours`,
                chain: [],
                type: {}
            },
            needAttentionPercentileThreshold: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.needAttentionPercentileThreshold`,
                chain: [],
                type: {}
            },
            disable: {
                name: `${baseName}.teamBadges.avgPRCycleTimeBadge.disable`,
                chain: [],
                type: {}
            },
        },
        prReviewersPercentBadge: {
            topPerformerPercentageOfReviewers: {
                name: `${baseName}.teamBadges.prReviewersPercentBadge.topPerformerPercentageOfReviewers`,
                chain: [],
                type: {}
            },
            needAttentionPercentageOfReviewers: {
                name: `${baseName}.teamBadges.prReviewersPercentBadge.needAttentionPercentageOfReviewers`,
                chain: [],
                type: {}
            },
            disable: {
                name: `${baseName}.teamBadges.prReviewersPercentBadge.disable`,
                chain: [],
                type: {}
            },
        },
        workDistributionBugsPercentBadge: {
            topPerformerBugsPercentThreshold: {
                name: `${baseName}.teamBadges.workDistributionBugsPercentBadge.topPerformerBugsPercentThreshold`,
                chain: [],
                type: {}
            },
            onTheRiseBugsPercentThreshold: {
                name: `${baseName}.teamBadges.workDistributionBugsPercentBadge.onTheRiseBugsPercentThreshold`,
                chain: [],
                type: {}
            },
            needAttentionBugsPercentThreshold: {
                name: `${baseName}.teamBadges.workDistributionBugsPercentBadge.needAttentionBugsPercentThreshold`,
                chain: [],
                type: {}
            },
            disable: {
                name: `${baseName}.teamBadges.workDistributionBugsPercentBadge.disable`,
                chain: [],
                type: {}
            },
        },
        mttrBadge: {
            topPerformerPercentileThreshold: {
                name: `${baseName}.teamBadges.mttrBadge.topPerformerPercentileThreshold`,
                chain: [],
                type: {}
            },
            topPerformerMttrThresholdHoursForTopPercentile: {
                name: `${baseName}.teamBadges.mttrBadge.topPerformerMttrThresholdHoursForTopPercentile`,
                chain: [],
                type: {}
            },
            topPerformerMttrThresholdHours: {
                name: `${baseName}.teamBadges.mttrBadge.topPerformerMttrThresholdHours`,
                chain: [],
                type: {}
            },
            needAttentionMttrThresholdHours: {
                name: `${baseName}.teamBadges.mttrBadge.needAttentionMttrThresholdHours`,
                chain: [],
                type: {}
            },
            needAttentionNegativeTrendMttrThresholdHours: {
                name: `${baseName}.teamBadges.mttrBadge.needAttentionNegativeTrendMttrThresholdHours`,
                chain: [],
                type: {}
            },
            disable: {
                name: `${baseName}.teamBadges.mttrBadge.disable`,
                chain: [],
                type: {}
            },
        },
    }
};
//# sourceMappingURL=daily-dev-stats.js.map